import React, { useState } from "react";
import { Button, Card } from "react-bootstrap";
import "./font.css";

function CaseStudy({ scenario, approach, index }) {
  const [showApproach, setShowApproach] = useState(false);

  return (
    <Card className="question-reveal-card">
      <Card.Body style={{ backgroundColor: "#934cce5e" }}>
        <Card.Title className="question">
          {index}. CaseStudy: {scenario}
        </Card.Title>
        {showApproach && <Card.Text>{approach}</Card.Text>}
        <Button
          variant="primary"
          onClick={() => setShowApproach(!showApproach)}
        >
          {showApproach ? "Hide Approach" : "Reveal Approach"}
        </Button>
      </Card.Body>
    </Card>
  );
}

export default CaseStudy;
